export const DOCUMENT_VIEWER_WORKER_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js';
